// extracted by mini-css-extract-plugin
export var standaloneTable = "_fk-0";
export var standaloneTableWithBodyFill = "_fk-1";
export var withExtraHeader = "_fk-2";